/**
 * Журнал действий.
 *
 * Один журнал на платформу: сюда пишут и бренды, и сотрудники. Актор вида
 * `admin:почта` — это решение платформы, всё остальное — действия партнёра
 * или самого участника.
 */
import { Card, Empty, Skeleton, fmtDateTime } from '@allswipes/ui';
import { useState } from 'react';

import { api } from '../api';
import { Layout } from '../components/Layout';
import { useResource } from '../hooks';

export function AuditScreen() {
  const [entity, setEntity] = useState('');
  const data = useResource(() => api.adminAudit({ entity, limit: 300 }), [entity]);

  return (
    <Layout title="Журнал" subtitle="кто что сделал и когда">
      <div className="chips" style={{ marginBottom: 14 }}>
        {[
          { key: '', label: 'Всё' },
          { key: 'claim', label: 'Призы и отзывы' },
          { key: 'brand', label: 'Бренды' },
          { key: 'campaign', label: 'Акции' },
          { key: 'slide', label: 'Полоса' },
          { key: 'admin', label: 'Сотрудники' },
        ].map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`chip ${entity === tab.key ? 'on' : ''}`}
            onClick={() => setEntity(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {data.loading && <Skeleton count={5} height={40} />}
      {data.data && data.data.entries.length === 0 && <Empty icon="scroll" title="Записей нет" />}

      {data.data && data.data.entries.length > 0 && (
        <Card>
          <div className="scrollx">
          <table className="tbl">
            <thead>
              <tr>
                <th>Когда</th>
                <th>Кто</th>
                <th>Что</th>
                <th>Объект</th>
              </tr>
            </thead>
            <tbody>
              {data.data.entries.map((entry) => (
                <tr key={entry.id}>
                  <td className="faint">{fmtDateTime(entry.created_at)}</td>
                  <td className="mono">{entry.actor || '—'}</td>
                  <td>{entry.action}</td>
                  <td className="mono faint">
                    {entry.entity}
                    {entry.entity_id ? ` · ${entry.entity_id.slice(-6)}` : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </Card>
      )}
    </Layout>
  );
}
